
import axios from '../../helpers/axios';


export const updatedContactM = (id, updateContactM) => axios.patch(`/contactM/update/${id}`, updateContactM)
export const deletedContactM = (id) => axios.delete(`/contactM/delete/${id}`)
